module.exports = __webpack_public_path__ + "img/5.20988412.jpg";